import isEmpty from "lodash/isEmpty";
import Bugsnag from "@bugsnag/js";

export const ANALYTIC_EVENTS = {
  IDENTIFY_USER: "identify_user",
  FAQ_CLICKED: "faq_clicked",
  DEMO_REQUESTED: "demo_requested",
  PRICING_CLICKED: "pricing_clicked",
  PROFILE_UPDATED: "profile_updated",
  DOCUMENT_CREATED: "document_created",
  DOCUMENT_UPDATED: "document_updated",
  DOCUMENT_DELETED: "document_deleted",
  COMPANY_CREATED: "company_created",
  COMPANY_UPDATED: "company_updated",
  COMPANY_TIMEZONE_UPDATED: "company_timezone_updated",
  LOAN_CREATED: "loan_created",
  LOAN_UPDATED: "loan_updated",
  LOAN_DELETED: "loan_deleted",
  LOAN_PROPERTY_DETAIL_UPDATED: "loan_property_detail_updated",
  LOAN_BORROWER_ADDED: "loan_borrower_added",
  LOAN_BORROWER_UPDATED: "loan_borrower_updated",
  LOAN_BORROWER_DELETED: "loan_borrower_deleted",
  LOAN_REFERRER_ADDED: "loan_referrer_added",
  LOAN_REFERRER_DELETED: "loan_referrer_deleted",
  LOAN_STATUS_CHANGED: "loan_status_changed",
  LOAN_ESTIMATED_CLOSING_DATE_CHANGED: "loan_estimated_closing_date_changed",
  LOAN_NOTE_CREATED: "loan_note_created",
  LOAN_NOTE_UPDATED: "loan_note_updated",
  LOAN_NOTE_DELETED: "loan_note_deleted",
  LOAN_EMPLOYEE_CREATED: "loan_employee_created",
  LOAN_EMPLOYEE_DELETED: "loan_employee_deleted",
  LOAN_PACKAGE_DOWNLOADED: "loan_package_downloaded",
  NEEDS_LIST_BORROWER_REMINDER_SENT: "needs_list_borrower_reminder_sent",
  NEEDS_LIST_DOCUMENT_CREATED: "needs_list_document_created",
  NEEDS_LIST_DOCUMENT_UPDATED: "needs_list_document_updated",
  NEEDS_LIST_DOCUMENT_DELETED: "needs_list_document_deleted",
  NEEDS_LIST_DOCUMENT_FILE_CREATED: "needs_list_document_file_created",
  NEEDS_LIST_DOCUMENT_FILE_CREATED_BY_BORROWER: "needs_list_document_file_created_by_borrower",
  NEEDS_LIST_DOCUMENT_FILE_APPROVED: "needs_list_document_file_approved",
  NEEDS_LIST_DOCUMENT_FILE_REJECTED: "needs_list_document_file_rejected",
  NEEDS_LIST_DOCUMENT_FILE_PREVIEW: "needs_list_document_file_preview",
  NEEDS_LIST_DOCUMENT_FILE_DOWNLOAD: "needs_list_document_file_download",
  NEEDS_LIST_DOCUMENT_FILE_DELETED: "needs_list_document_file_deleted",
  NEEDS_LIST_DOCUMENT_FILE_DELETED_BY_BORROWER: "needs_list_document_file_deleted_by_borrower",
  LOAN_LENDER_CALL_LOG_ITEM_CREATED: "loan_lender_call_log_item_created",
  LOAN_LENDER_CALL_LOG_ITEM_UPDATED: "loan_lender_call_log_item_updated",
  LOAN_LENDER_CALL_LOG_ITEM_DELETED: "loan_lender_call_log_item_deleted",
  LOAN_SUMMARY_CREATED: "loan_summary_created",
  LOAN_SUMMARY_UPDATED: "loan_summary_updated",
  LOAN_SUMMARY_DELETED: "loan_summary_deleted",
  LENDER_LOAN_SUMMARY_CREATED: "lender_loan_summary_created",
  LENDER_LOAN_SUMMARY_DELETED: "lender_loan_summary_deleted",
  LENDER_LOAN_SUMMARY_RESPONDED: "lender_loan_summary_responded",
  LENDER_LOAN_SUMMARY_PACKAGE_DOWNLOADED: "lender_loan_summary_package_downloaded",
  LOAN_SUMMARY_NEEDS_LIST_FILE_CREATED: "loan_summary_needs_list_file_created",
  LOAN_SUMMARY_NEEDS_LIST_FILE_DELETED: "loan_summary_needs_list_file_deleted",
  LOAN_CALL_LOG_SMART_SORT: "loan_call_log_smart_sort",
  TEAM_MEMBER_CREATED: "team_member_created",
  TEAM_MEMBER_UPDATED: "team_member_updated",
  TEAM_MEMBER_DELETED: "team_member_deleted",
  TEAM_MEMBER_INVITED: "team_member_invited",
  CONTACT_CREATED: "contact_created",
  CONTACT_UPDATED: "contact_updated",
  CONTACT_DELETED: "contact_deleted",
  CONTACTS_IMPORTED: "contacts_imported",
  CONTACTS_REVIEWED: "contacts_reviewed",
  CONTACTS_DELETED: "contacts_deleted",
  LENDING_COMPANY_CREATED: "lending_company_created",
  LENDING_COMPANY_UPDATED: "lending_company_updated",
  LENDING_COMPANY_DELETED: "lending_company_deleted",
  LENDING_COMPANY_STATE_CREATED: "lending_company_state_created",
  LENDING_COMPANY_STATES_CREATED: "lending_company_states_created",
  LENDING_COMPANY_STATE_DELETED: "lending_company_state_deleted",
  LENDING_COMPANY_STATES_DELETED: "lending_company_states_deleted",
  LENDING_COMPANY_LOAN_TYPE_CREATED: "lending_company_loan_type_created",
  LENDING_COMPANY_LOAN_TYPES_CREATED: "lending_company_loan_types_created",
  LENDING_COMPANY_LOAN_TYPE_DELETED: "lending_company_loan_type_deleted",
  LENDING_COMPANY_LOAN_TYPES_DELETED: "lending_company_loan_types_deleted",
  LENDING_COMPANY_PROPERTY_TYPE_CREATED: "lending_company_property_type_created",
  LENDING_COMPANY_PROPERTY_TYPES_CREATED: "lending_company_property_types_created",
  LENDING_COMPANY_PROPERTY_TYPE_DELETED: "lending_company_property_type_deleted",
  LENDING_COMPANY_PROPERTY_TYPES_DELETED: "lending_company_property_types_deleted",
  LENDING_COMPANY_LOAN_PROGRAM_CREATED: "lending_company_loan_program_created",
  LENDING_COMPANY_LOAN_PROGRAMS_CREATED: "lending_company_loan_programs_created",
  LENDING_COMPANY_LOAN_PROGRAM_DELETED: "lending_company_loan_program_deleted",
  LENDING_COMPANY_LOAN_PROGRAMS_DELETED: "lending_company_loan_programs_deleted",
  NEEDS_LIST_TEMPLATE_CLONED: "needs_list_template_cloned",
  NEEDS_LIST_TEMPLATE_CREATED: "needs_list_template_created",
  NEEDS_LIST_TEMPLATE_UPDATED: "needs_list_template_updated",
  NEEDS_LIST_TEMPLATE_DELETED: "needs_list_template_deleted",
  BORROWER_NEEDS_LIST_TEMPLATE_CREATED: "borrower_needs_list_template_created",
  NEEDS_LIST_TEMPLATE_DOCUMENT_CREATED: "needs_list_template_document_created",
  NEEDS_LIST_TEMPLATE_DOCUMENTS_CREATED: "needs_list_template_documents_created",
  NEEDS_LIST_TEMPLATE_DOCUMENT_DELETED: "needs_list_template_document_deleted",
  NEEDS_LIST_TEMPLATE_DOCUMENTS_DELETED: "needs_list_template_documents_deleted",
  BUTTON_CLICKED: "button_clicked",
  LENDER_CALL_LOG_NOTE_CREATED: "lender_call_log_note_created",
  LENDER_CALL_LOG_NOTE_UPDATED: "lender_call_log_note_updated",
  LENDER_CALL_LOG_NOTE_DELETED: "lender_call_log_note_deleted",
  LENDER_CALL_LOG_NOTE_CREATED_BY_LENDER: "lender_call_log_note_created_by_lender",
  LENDER_CALL_LOG_NOTE_UPDATED_BY_LENDER: "lender_call_log_note_updated_by_lender",
  LENDER_CALL_LOG_NOTE_DELETED_BY_LENDER: "lender_call_log_note_deleted_by_lender",
  COMPANY_NOTIFICATION_SCHEDULE__UPDATED: "company_notification_updated",
  LENDERS_IMPORT_WIZARD: "lenders_import_wizard",
  LENDER_ATTRIBUTE_CREATED: "lender_attribute_created",
  LENDER_ATTRIBUTE_UPDATED: "lender_attribute_updated",
  LENDING_PROGRAM_CREATED: "lending_program_created",
  LENDING_PROGRAM_UPDATED: "lending_program_updated",
  LENDING_PROGRAM_DELETED: "lending_program_deleted",
  LENDING_PROGRAM_PARAMETER_ADDED: "lending_program_parameter_added",
  LENDING_PROGRAM_PARAMETER_REMOVED: "lending_program_parameter_updated",
  LENDING_PROGRAM_PARAMETERS_ADDED: "lending_program_parameters_added",
  LENDING_PROGRAM_PARAMETERS_REMOVED: "lending_program_parameters_removed",
  LENDER_OFFER_CREATED: "lender_offer_created",
  LENDER_OFFER_UPDATED: "lender_offer_updated",
  LENDER_OFFER_DELETED: "lender_offer_deleted",
  LENDER_OFFER_FILE_CREATED: "lender_offer_file_created",
  LENDER_OFFER_FILE_DELETED: "lender_offer_file_deleted",
  LENDER_OFFER_FILE_PREVIEW: "lender_offer_file_preview",
  LENDER_OFFER_FILE_DOWNLOAD: "lender_offer_file_download",
  BORROWER_NEEDS_LIST_INSTRUCTIONS_UPDATED: "borrower_needs_list_instructions_updated",
  BROKER_REQUESTED_LENDER_PARAMETERS_UPDATED: "broker_requested_lender_parameters_updated",
  LENDER_DASHBOARD_PROFILE_UPDATED: "lender_dashboard_profile_updated",
  LENDER_DASHBOARD_LENDING_PROGRAM_CREATED: "lender_dashboard_lending_program_created",
  LENDER_DASHBOARD_LENDING_PROGRAM_UPDATED: "lender_dashboard_lending_program_updated",
  LENDER_DASHBOARD_LENDING_PROGRAM_DELETED: "lender_dashboard_lending_program_deleted",
  LENDER_DASHBOARD_LENDING_PROGRAM_PARAMETER_CREATED: "lender_dashboard_lending_program_parameter_created",
  LENDER_DASHBOARD_LENDING_PROGRAM_PARAMETER_DELETED: "lender_dashboard_lending_program_parameter_deleted",
  CONTACT_FILE_CREATED: "contact_file_created",
  CONTACT_FILE_DELETED: "contact_file_deleted",
  CONTACT_FILE_PREVIEW: "contact_file_preview",
  CONTACT_FILE_DOWNLOAD: "contact_file_download",
  RESOURCE_SHARE_CREATED: "resource_share_created",
  RESOURCE_SHARE_DELETED: "resource_share_deleted",
  RESOURCE_SHARE_PREVIEWED: "resource_share_previewed",
  RESOURCE_SHARE_DOWNLOADED: "resource_share_downloaded",
  // Lender Board Events
  LENDER_BOARD_CREATED: "lender_board_created",
  LENDER_BOARD_UPDATED: "lender_board_updated",
  LENDER_BOARD_REMINDER_SENT: "lender_board_reminder_sent",
  LENDER_BOARD_CLOSED: "lender_board_closed",
  LENDER_BOARD_APPROVED: "lender_board_approved",
  LENDER_BOARD_REOPENED: "lender_board_reopened",
  LENDER_BOARD_DELETED: "lender_board_deleted",
  // Lender Board Chat Events
  LENDER_BOARD_MESSAGE_CREATED: "lender_board_message_created",
  LENDER_BOARD_MESSAGE_UPDATED: "lender_board_message_updated",
  LENDER_BOARD_MESSAGE_DELETED: "lender_board_message_deleted",
  // Lender Board Offer Events
  LENDER_BOARD_OFFER_CREATED: "lender_board_offer_created",
  LENDER_BOARD_OFFER_UPDATED: "lender_board_offer_updated",
  LENDER_BOARD_OFFER_DELETED: "lender_board_offer_deleted",
  LENDER_BOARD_OFFER_FILE_UPLOADED: "lender_board_offer_file_uploaded",
  LENDER_BOARD_OFFER_FILE_DELETED: "lender_board_offer_file_deleted",
  LENDER_BOARD_OFFER_FILE_PREVIEWED: "lender_board_offer_file_previewed",
  LENDER_BOARD_OFFER_FILE_DOWNLOADED: "lender_board_offer_file_downloaded",
  CAPWORKS_MARKETPLACE_DEAL_CONNECTION_REQUEST_SENT: "capworks_marketplace_deal_connection_request_sent",
  CAPWORKS_MARKETPLACE_DEAL_ADDED_TO_PIPELINE: "capworks_marketplace_deal_added_to_pipeline",
  CAPWORKS_MARKETPLACE_DEAL_REMINDER_SENT: "capworks_marketplace_deal_reminder_sent",
  LENDER_HUB_DEAL_ACCEPTED: "lender_hub_deal_accepted",
  LENDER_HUB_DEAL_CLOSED: "lender_hub_deal_closed",
  LENDER_HUB_DEAL_REOPENED: "lender_hub_deal_reopened",
  // Lender Hub Offer Events
  LENDER_HUB_OFFER_CREATED: "lender_hub_offer_created",
  LENDER_HUB_OFFER_UPDATED: "lender_hub_offer_updated",
  LENDER_HUB_OFFER_DELETED: "lender_hub_offer_deleted",
  LENDER_HUB_OFFER_FILE_UPLOADED: "lender_hub_offer_file_uploaded",
  LENDER_HUB_OFFER_FILE_DOWNLOADED: "lender_hub_offer_file_downloaded",
  LENDER_HUB_OFFER_FILE_PREVIEWED: "lender_hub_offer_file_previewed",
  LENDER_HUB_OFFER_FILE_DELETED: "lender_hub_offer_file_deleted",
  // Lender Hub Message Events
  LENDER_HUB_MESSAGE_CREATED: "lender_hub_message_created",
  LENDER_HUB_MESSAGE_UPDATED: "lender_hub_message_updated",
  LENDER_HUB_MESSAGE_DELETED: "lender_hub_message_deleted",
  // Lender Hub Loan Summary Need List File Events
  LENDER_HUB_LOAN_SUMMARY_NEED_LIST_FILE_PREVIEWED: "lender_hub_loan_summary_need_list_file_previewed",
  LENDER_HUB_LOAN_SUMMARY_NEED_LIST_FILE_DOWNLOADED: "lender_hub_loan_summary_need_list_file_downloaded",
  // Lender Auth Events
  LENDER_SIGNED_UP: "lender_signed_up",
  LENDER_LOGGED_IN: "lender_logged_in",
};

export const ANALYTICS_USER_TYPES = {
  BROKER: "broker",
  LENDER: "lender",
  REFERRER: "referrer",
  BORROWER: "borrower",
};

export function sendAnalytics(eventName, data = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];

  try {
    // Send events to Mixpanel
    window.mixpanel?.track(eventName, { ...data });

    // Send events to RudderStack
    window.rudderanalytics?.track(eventName, { ...data });

    window.dataLayer.push({
      event: eventName,
      ...data,
    });
  } catch (error) {
    Bugsnag.notify(error);
  }
}

export function sendCollectionToAnalytics(eventName, collection) {
  if (!collection.length) return;

  collection.forEach(item => {
    sendAnalytics(eventName, { ...item });
  });
}

export function identifyUser(user) {
  window.dataLayer = window.dataLayer || [];

  if (isEmpty(user)) return;

  sendAnalytics(ANALYTIC_EVENTS.IDENTIFY_USER, user);
}

export function initializeUser(userId, data) {
  if (typeof window === "undefined" || !userId) return;

  identifyUser({
    ...data,
    userId: data.userId,
    userType: ANALYTICS_USER_TYPES.BROKER,
    roleId: data.employeeRoleId,
    firstName: data.firstName,
    lastName: data.lastName,
    fullName: `${data.firstName} ${data.lastName}`,
    email: data.email,
    companyId: data.companyId,
    companyName: data.legalName,
    avatarUrl: data.pictureUrl,
    membershipDate: new Date(data.createdAt).toISOString(),
    environment: process.env.NODE_ENV,
  });

  Bugsnag.setUser(data.userId, data.email, `${data.firstName} ${data.lastName}`);
}
